import * as facebookApi from '../api/facebook';
import {formatFacebookServerProps} from './utils';

import axios from '@customAxios';

import {IS_PROD} from '@variables';

export * from './utils';

const trackInteractionEvent = (
  eventName,
  experimentName = null,
  customerKeyUrlsafe = null,
  profileKeyUrlsafe = null,
  isAdmin = false
) => {
  if (isAdmin) {
    // Added in for Pricing test to ensure tracking events are captured before some
    // hardcoded redirects
    return Promise.resolve();
  }
  const data = {
    eventName: eventName,
    experimentName: experimentName,
    profileKey: profileKeyUrlsafe,
    customerKey: customerKeyUrlsafe,
  };
  return axios.post('/api/interaction_event/save', data).catch(() => {});
};

const trackBingEvent = (eventName) => {
  window.uetq = window.uetq || [];
  window.uetq.push({el: eventName});
};

const trackTikTokEvent = (eventName, props) => {
  window.ttq && window.ttq.track(eventName, props);
};

const setGoogleAnalyticsCustomDimension = (dimension) => {
  window.gtag && window.gtag('event', 'accountVisit', {dimension2: dimension});
};

const trackGoogleAnalyticsEvent = (eventLabel) => {
  window.gtag && window.gtag('event', 'click', {event_category: 'button', event_label: eventLabel});
};

const trackAdWordsConversion = (conversionId, userData = null) => {
  // Configuration for enhanced conversion tracking. Data being passed must be stored in a global
  // variable called enhanced_conversion_data so it can be recognized by gtag
  // Used for AW-936326366/No4iCJTm9GsQ3um8vgM
  if (userData) {
    window.enhanced_conversion_data = userData;
  }
  if (window.gtag) {
    window.gtag('event', 'conversion', {send_to: conversionId});
  }
};

const trackCAConversion = (consumerAffairsId) => {
  window.fireTrackingPixel &&
    window.fireTrackingPixel(
      'https://www.consumeraffairs.com/brands/app/partners/cpixel/v2' +
        `/?conaffid=${consumerAffairsId}&status=closed`
    );
};

const trackRakutenEvent = (rakutenProps) => {
  window.fireRakutenPixel && window.fireRakutenPixel(rakutenProps);
};

const trackPodsightsEvent = (eventName, podsightsProps = {}) => {
  window.pdst && window.pdst(eventName, podsightsProps);
};

const trackFriendBuyEvent = (eventName, customerId, eventPayload, isAdmin = false) => {
  if (IS_PROD && !isAdmin) {
    window.friendbuyAPI = window.friendbuyAPI || [];
    window.friendbuyAPI.push([
      'track',
      eventName,
      {
        id: customerId,
        ...eventPayload,
      },
    ]);
  }
};

const sendGoogleTagManagerEvent = (eventVariablesObject = {}) => {
  const googleDataLayer = window.dataLayer ? window.dataLayer : [];
  googleDataLayer.push(eventVariablesObject);
};

const trackFacebookEvent = (eventName, props, uuid) => {
  // Only track event if profile has dogs.
  if (props.num_dogs) {
    // eventID and eventName used for deduplicating server and client events.
    const eventID = {
      eventID: uuid,
    };
    window.fbq && window.fbq('track', eventName, props, eventID);
  }
};

/* Function to track facebook CAPI events on the server to deduplicate events. */
const trackServerSideFacebookEvent = (eventName, uuid, props) => {
  const formattedProps = formatFacebookServerProps(props);
  const data = {
    ccpaOptOut: window.IS_CCPA_OPTED_OUT,
    eventName: eventName,
    facebookCustomProps: formattedProps,
    uuid: uuid,
  };
  facebookApi.sendEvent(data).catch((error) => {
    console.error('Error sending Facebook event:', error);
  });
};

export {
  sendGoogleTagManagerEvent,
  setGoogleAnalyticsCustomDimension,
  trackAdWordsConversion,
  trackBingEvent,
  trackCAConversion,
  trackFacebookEvent,
  trackFriendBuyEvent,
  trackGoogleAnalyticsEvent,
  trackPodsightsEvent,
  trackRakutenEvent,
  trackTikTokEvent,
  trackInteractionEvent,
  trackServerSideFacebookEvent,
};
